import { render, staticRenderFns } from "./radiobox.vue?vue&type=template&id=35f2419c&scoped=true&"
import script from "./radiobox.vue?vue&type=script&lang=js&"
export * from "./radiobox.vue?vue&type=script&lang=js&"
import style0 from "./radiobox.vue?vue&type=style&index=0&id=35f2419c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f2419c",
  null
  
)

export default component.exports